import { useEffect, useState } from "react"

import { useAuthContext } from "@contexts/authContext"
import { fontSize, size } from "@styles/theme"
import { useNavigate } from "react-router-dom"
import styled from "@emotion/styled/macro"

import LocationRandomizerForm from "@forms/nearby_screen_settings_forms/LocationRandomizerForm"
import { PiCaretLeftBold, PiInfoBold } from "react-icons/pi"
import AccordionItem from "@elements/AccordionItem"
import { MapLegendButton } from './MapLegendButton'
import { Box, ButtonBase } from "@mui/material"
import { Accordion, } from "@base-ui/react"
import { TbMap2 } from "react-icons/tb"

const leftMargin = size(3)

const Outer = styled.div`
  height: 100dvh;
`

const Container = styled(Box)`
  background-color: black;
  width: 85dvw;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
`

const Title = styled.h2`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: ${fontSize('sm')};
  font-weight: bold;
  letter-spacing: 0.05rem;
`

const BackButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  border-radius: 100%;
  padding: ${size(3.5)} 0 ${size(3.5)} ${leftMargin};
`
const Back = () => {
  const navigate = useNavigate()
  return (
    <BackButton onClick={() => navigate(-1)}>
      <PiCaretLeftBold size={size(2)} />&nbsp;&nbsp;
      <Title>Map & Grid Settings</Title>
    </BackButton>
  )
}

const NearbyScreenDrawerContents = ({ }) => {
  const [isInitialized, setIsInitialized] = useState(false)
  const { state: authState } = useAuthContext()

  // We want the user to be authenticated and set before continuing
  useEffect(() => {
    if (authState.user && !isInitialized) setIsInitialized(true)
  }, [authState.user, isInitialized])

  if (!isInitialized) return (
    <Outer>
      <Container>
        <Back />
      </Container>
    </Outer>
  );
  return (
    <Outer>
      <Container>
        <Back />
        <Accordion.Root
          defaultValue={['a', 'b']}
          keepMounted
          multiple>
          <AccordionItem
            value='a'
            HeaderIcon={() => <PiInfoBold size={size(2)} />}
            headerText='INFORMATION'>
            <MapLegendButton />
          </AccordionItem>
          <AccordionItem
            value='b'
            HeaderIcon={() => <TbMap2 size={size(2)} />}
            headerText='LOCATION RANDOMIZER'>
            <LocationRandomizerForm />
          </AccordionItem>
        </Accordion.Root>
      </Container>
    </Outer>
  )
}

export default NearbyScreenDrawerContents
